import BaseMenuPrincipal from "../../../componentes/BaseMenuPrincipalComponent/BaseMenuPrincipal";
import { ProjetosComponent } from "../../../componentes/ProjetosComponent/ProjetosComponent";


const Projetos = () => {

    return (
        <>
            <BaseMenuPrincipal
                InfoLateral={<ProjetosComponent />}
            />
            
            
        </>
    );
};

export default Projetos;